import React, { PropTypes } from 'react'

import './StarRating.scss'

function generateStars (starCount) {
  let stars = []
  for (let i = 1; i <= starCount; i++) {
    stars.push(<span key={i} className='StarRating-star icon-star-full' />)
  }
  return stars
}

const StarRating = (props) => {
  const {
    value,
    min = 0.00,
    max = 1.00,
    starCount = 5
  } = props

  const normalize = (x, min, max) => (x - min) / (max - min)

  let safeValue = Math.max(value, min)
  safeValue = Math.min(safeValue, max)

  const normalizedValue = normalize(safeValue, min, max)

  const stars = generateStars(starCount)
  const goldWidth = (normalizedValue * 100) + '%'

  return (
    <div className='StarRating'>
      <div className='StarRating-stars'> {stars} </div>
      <div className='StarRating-starsGold' style={{width: goldWidth}}> {stars} </div>
    </div>
  )
}
StarRating.displayName = 'StarRating'
StarRating.propTypes = {
  value: PropTypes.number.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  starCount: PropTypes.number
}

export default StarRating



// WEBPACK FOOTER //
// ./src/screens/App/shared/components/StarRating/StarRating.js